import i18n from '@i18n';

// o x dni / o 1 den a x hodin / o x hodin a y minut / o y minut
export default function customDateUntilFormat(actualDate, expirationDate) {
    const hoursRemainging = expirationDate.diff(actualDate, 'hours');
    const minutesRemaining = expirationDate.diff(actualDate, 'minutes');
    if (hoursRemainging < 48 && hoursRemainging > 24) {
        return i18n('scoreboard.prematch.inOneDay') + getHoursText(hoursRemainging - 24);
    } else if (hoursRemainging === 24) {
        return i18n('scoreboard.prematch.inOneDayOnly');
    } else if (hoursRemainging < 24 && hoursRemainging > 0) {
        return (
            `${i18n('scoreboard.prematch.in')}` +
            getHoursText(hoursRemainging) +
            ` ${i18n('scoreboard.prematch.and')}` +
            getMinutesText(minutesRemaining - hoursRemainging * 60)
        );
    } else if (hoursRemainging === 0 && minutesRemaining > 1) {
        return `${i18n('scoreboard.prematch.in')}` + getMinutesText(minutesRemaining);
    }
    return expirationDate.from(actualDate);
}

function getHoursText(hoursRemainging) {
    if (hoursRemainging > 4) {
        return ` ${i18n('scoreboard.prematch.inHodin', hoursRemainging)}`;
    } else if (hoursRemainging < 5 && hoursRemainging > 1) {
        return ` ${i18n('scoreboard.prematch.inHodiny', hoursRemainging)}`;
    } else if (hoursRemainging === 1) {
        return ` ${i18n('scoreboard.prematch.inHodinu', hoursRemainging)}`;
    }
    return '';
}

function getMinutesText(minutesRemaining) {
    if (minutesRemaining > 4) {
        return ` ${i18n('scoreboard.prematch.inMinut', minutesRemaining)}`;
    } else if (minutesRemaining < 5 && minutesRemaining > 1) {
        return ` ${i18n('scoreboard.prematch.inMinuty', minutesRemaining)}`;
    } else if (minutesRemaining === 1) {
        return ` ${i18n('scoreboard.prematch.inMinutu', minutesRemaining)}`;
    }
    return '';
}

export const _testOnly = { customDateUntilFormat };
